import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useAemConfig } from '@as-react/common-components';
import CustomerApi from '../../api/customer/CustomerApi';
import { AccountOverviewInfo } from '../../components/account/account-overview-info/AccountOverviewInfo';
import { sortAlphabetically } from '@as-react/common-utils';
import { useIsMounted } from '@as/cotopaxi';
import { useQuery } from '@tanstack/react-query';
import { customerQueries } from '@as-react/common-queries';
const AccountOverviewInfoContainer = ({ editProfileLink, title, }) => {
    const { defaultRequestParams, servicesEndpoint, lang } = useAemConfig();
    const isMounted = useIsMounted();
    const { getCountries } = customerQueries({ servicesEndpoint, defaultRequestParams });
    const [customerProfile, setCustomerProfile] = useState(null);
    const [customerCountry, setCustomerCountry] = useState();
    const { data: countries } = useQuery(getCountries({
        select: data => sortAlphabetically(data, `countryDescriptionTranslations.${lang.toUpperCase()}`),
    }));
    useEffect(() => {
        const getCustomerProfile = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const profile = yield CustomerApi.getProfile(servicesEndpoint, defaultRequestParams);
                if (isMounted()) {
                    setCustomerProfile(profile);
                }
            }
            catch (_a) { }
        });
        getCustomerProfile();
    }, [isMounted]);
    useEffect(() => {
        const getCountries = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                if (isMounted() && countries) {
                    const currentCountry = countries.find(country => country.idCountry === customerProfile.address.idCountry);
                    const countryName = currentCountry.countryDescriptionTranslations[lang.toUpperCase()];
                    setCustomerCountry(countryName);
                }
            }
            catch (_a) { }
        });
        if (customerProfile) {
            getCountries();
        }
    }, [customerProfile, isMounted]);
    if (!customerProfile) {
        return null;
    }
    return (_jsx(AccountOverviewInfo, { country: customerCountry, profile: customerProfile, editProfileLink: editProfileLink, title: title }));
};
export default AccountOverviewInfoContainer;
